export default __webpack_public_path__ + "static/media/settings.c284186b.svg";